// import tns from "tiny-slider";
import { tns } from 'tiny-slider/src/tiny-slider.module.js';
import 'tiny-slider/dist/tiny-slider.css';
import 'tiny-slider/dist/tiny-slider.helper.ie8.js';

import '../../../src/docReady.js';
import Match from '../../../src/Match.js'; // easing
import isMobile from '../../../src/isMobile.js';
import Helper from '../../../src/Helper.js'; // easing
import './style.scss';

const moduleSelector = '.eiovisual-previews1';

/**
 * Classe esempio
 */
class Module {
    
    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo previews1');
    }

    // _________________________________________________________________________
    
    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);

            // avvia il carousel per ogni modulo trovato
            $modules.forEach(($module) => {
                new ModuleFeature($module);
            });
        });
    }
}

class ModuleFeature {

    constructor($module) {
        this.$module = $module;
        
        this.init_feature();
    }

    // _________________________________________________________________________

    /**
     * Metodo di debounce, usato per addEventListener
     * @param {type} func
     * @param {type} delay
     * @returns {Function}
     */
    debounce(func, delay) {
        let inDebounce

        return () => {
            const context = this
            const args = arguments
            clearTimeout(inDebounce)
            inDebounce = setTimeout(() => func.apply(context, args), delay)
        }
    }

    // _________________________________________________________________________

    init_feature() {
        // Tasks on images
        setTimeout(() => { this.task1() },0);
        setTimeout(() => { this.task3() },100);
    }

    /**
     * Altezza titolo
     * @returns {undefined}
     */
    task1() {
        // uniforma l'altezza degli elementi
        Match.height(this.$module.querySelectorAll('.item .title'));
    }
    
    /**
     * Altezza text
     * @returns {undefined}
     */
    task2() {
        // uniforma l'altezza degli elementi
        Match.height(this.$module.querySelectorAll('.item .text'));
    }

    /**
     * tiny slider
     * @returns {undefined}
     */
    task3() {

        var that = this;
        var id = this.$module.getAttribute('id');

        // DOCUMENTATION
        // https://github.com/ganlanyuan/tiny-slider
        var slider = tns({
            container: '#magazine-' + id,
            items: 1,
            mode:'gallery',
            items:1,
            slideBy: 'page',
            autoplay: false,
            autoWidth:false,
            mouseDrag:true,
            touch:true,
            nav: false,
            controls: false,
            swipeAngle: 25
            // preventScrollOnTouch:true
          });

    }

}

// export
export default new Module();